import * as React from "react";
import { TextLink } from "@ovotech/element";

const PHONE_NUMBER = "0330 303 5059";

export const PhoneContact = () => (
  <TextLink href={`tel:${PHONE_NUMBER.replace(/\s/g, "")}`}>
    {PHONE_NUMBER}
  </TextLink>
);
